import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import EventButton from '../../../modules/analytics/components/EventButton/EventButton';
var Indicator = function Indicator(_ref) {
  var index = _ref.index,
    currentIndex = _ref.currentIndex,
    changeCurrentIndex = _ref.changeCurrentIndex,
    event = _ref.event;
  return /*#__PURE__*/React.createElement(EventButton, {
    "aria-label": "Carousel image number ".concat(index),
    event: _objectSpread(_objectSpread({}, event), {}, {
      value: index
    }),
    className: "ic-carousel-indicator",
    style: {
      padding: 0,
      background: 'none'
    },
    onClick: function onClick() {
      return changeCurrentIndex(index);
    },
    size: "large",
    icon: index === currentIndex ? 'circle' : 'circle outline'
  });
};
Indicator.defaultProps = {
  event: {
    category: 'Carousel',
    action: 'Click',
    label: 'Image Collection'
  }
};
export default Indicator;